import { Module, VuexModule, MutationAction, Action } from "vuex-module-decorators";
import { ServicesFactoryInstance } from "../../components/Controls/ServicesFactory";
import { TypeAbsenceSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/TypeAbsenceSalarieDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Module({ namespaced: true })
class AbsencesStore extends VuexModule {
	public storeTypesAbsencePosableSalarie: TypeAbsenceSalarieDto[] = []; // Liste des types d'absences posables pour le salarié

	/**
     * Action pour récupérer les types d'absences posables pour le salarié
	 * Met à jour le store avec les types d'absences posables pour le salarié
     * @returns Les types d'absences posables pour le salarié dans le store
     */
	@MutationAction({ mutate: ["storeTypesAbsencePosableSalarie"] })
	public async fetchTypesAbsencesPosableSalarie(): Promise<{ storeTypesAbsencePosableSalarie: TypeAbsenceSalarieDto[] }> {
    	const data = await ServicesFactoryInstance.AbsencesService.getTypesAbsences();

    	return { storeTypesAbsencePosableSalarie: data };
	}

	/**
	 * Action pour initialiser les types d'absences posables pour le salarié
	 * Si les types d'absences posables pour le salarié ne sont pas encore chargés, on les charge
	 * @returns Promise<void>
	 */
	@Action
	public async initializeTypesAbsences(): Promise<void> {
    	// Si les données sont déjà chargées, ne rien faire
    	if (this.storeTypesAbsencePosableSalarie.length > 0) {
    		return;
    	}

    	try {
    		await this.context.dispatch("fetchTypesAbsencesPosableSalarie");
    	} catch (error) {
    		NotificationServiceInstance.SendFailed(
    			`Erreur lors de la récupération des types d'absences pour le salarié : ${(error as Error).message}`
    		);
    		throw error;
    	}
	}
}

export default AbsencesStore;



// WEBPACK FOOTER //
// ./src/store/modules/AbsencesStore.ts